import { Badge } from "@/components/ui/badge";

/**
 * Status pills route status strings through the brand palette:
 *
 * - online / applied / active   → secondary (Anietronic blue)
 * - offline / failed / rejected → destructive (deep red)
 * - pending / claiming / queued → warning (amber)
 * - everything else             → muted (grey)
 *
 * Green is intentionally avoided so the chrome stays
 * red / blue / black / grey / white.
 */
function variantFor(status: string): "secondary" | "destructive" | "warning" | "muted" {
  const normalized = status.toLowerCase();
  if (["online", "provisioned", "applied", "ok", "active"].includes(normalized)) return "secondary";
  if (["offline", "failed", "rejected", "error"].includes(normalized)) return "destructive";
  if (["pending", "claiming", "queued"].includes(normalized)) return "warning";
  return "muted";
}

export function StatusPill({ status }: { status: string }): JSX.Element {
  return (
    <Badge variant={variantFor(status)} className="capitalize">
      {status || "unknown"}
    </Badge>
  );
}
